import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import AntdIcon from '@ant-design/icons';
export var ImgIcon = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ImgIcon, _React$PureComponent);

  var _super = _createSuper(ImgIcon);

  function ImgIcon() {
    _classCallCheck(this, ImgIcon);

    return _super.apply(this, arguments);
  }

  _createClass(ImgIcon, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          src = _a.src,
          _a$alt = _a.alt,
          alt = _a$alt === void 0 ? '' : _a$alt,
          ariaHidden = _a.ariaHidden,
          other = __rest(_a, ["src", "alt", "ariaHidden"]);

      return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, other, {
        component: function component() {
          return /*#__PURE__*/React.createElement("img", {
            src: src,
            alt: alt,
            "aria-hidden": ariaHidden ? 'true' : 'false'
          });
        }
      }));
    }
  }]);

  return ImgIcon;
}(React.PureComponent);
export var SvgIcon = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(SvgIcon, _React$PureComponent2);

  var _super2 = _createSuper(SvgIcon);

  function SvgIcon() {
    _classCallCheck(this, SvgIcon);

    return _super2.apply(this, arguments);
  }

  _createClass(SvgIcon, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          Svg = _a.Svg,
          other = __rest(_a, ["Svg"]);

      return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, other, {
        component: function component() {
          return /*#__PURE__*/React.createElement(Svg, null);
        }
      }));
    }
  }]);

  return SvgIcon;
}(React.PureComponent);
export default {
  ImgIcon: ImgIcon,
  SvgIcon: SvgIcon
};